import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_RENT_RADIOGUIDE: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Гид надевает головной микрофон, подключенный к&nbsp;карманному передатчику',
            alt: 'Гид с микрофоном',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Слушателям раздают приемники и&nbsp;наушники для экскурсий',
            alt: 'Участники с приемниками и наушниками',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/listeners-with-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/listeners-with-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/listeners-with-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/listeners-with-headphones.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. В&nbsp;радиусе до&nbsp;200 метров всё, что говорит гид в&nbsp;микрофон для экскурсий, слышно в&nbsp;наушниках у&nbsp;экскурсантов',
            alt: 'Экскурсанты на разном расстоянии хорошо слышат гида',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/museum-tour-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/museum-tour.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/museum-tour-drawing.webp',
            image_webp: '/assets/images/ui/how-it-work/webp/museum-tour.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'Как в работе',
        description:
            'Радиогиды Reinvox в&nbsp;разных локациях: музей, улица, теплоход, завод',
        width: 876,
        height: 493,
        video_preview:
            '/assets/images/usage/radioguide/jpg-png/boat-group-tour-2.jpg',
        video_preview_webp:
            '/assets/images/usage/radioguide/webp/boat-group-tour-2.webp',
        duration: '0:30',
        link: '255b7f7e5b1a9dad1b4ab5a40fa83a43',
    },
}

export default HOW_IT_WORK_RENT_RADIOGUIDE
